import React from "react";
import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import DetailMobile from "./StrategicProductsMobile";
import DetailDesktop from "./StrategicProductsDesktop";

function StrategicProducts({ app, config }) {
	const isMobile = useMediaQuery({ query: "(max-width: 980px)" });

	return isMobile ? (
		<DetailMobile app={app} config={config} />
	) : (
		<DetailDesktop app={app} config={config} />
	);
}

StrategicProducts.defaultProps = {
	app: null,
	config: {},
};

StrategicProducts.propTypes = {
	app: PropTypes.object,
	config: PropTypes.object,
};

export default StrategicProducts;
